import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { SessionProvider } from 'providers';

function PrivateRoute({ component: Component, ...rest }) {
    const session = SessionProvider.get();
    return (
        <Route
            {...rest}
            render={props =>
                session.isValid ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/auth/login" />
                )
            }
        />
    );
}

export default PrivateRoute;